export enum FaxSentStatus {
  SENT = "Sent",
  FAILED = "Failed",
  IN_PROGRESS = "In Progress",
}
